import { BaseError } from '~/lib/error/base';

export class LoginFailedError extends BaseError {
  constructor(message: string) {
    super({ code: 'LOGIN_FAILED', message });
  }
}
